import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { SessionService } from '../session.service';

export const isAdmin: CanMatchFn = () => {
    const router = inject(Router);
    const session = inject(SessionService);

    if (!session.user()?.isBackend) {
        localStorage.setItem('redirectTo', window.location.pathname);

        return router.parseUrl('/');
    }

    return true;
};
